export default class BestellungTrinkgeldRequest {
  bestellungId: string
  type: string
  betrag: number
}
